
import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box } from '@material-ui/core';
import Accounts from './Accounts'; // Import your Accounts component
import Autoreply from './Autoreply'; // Import your Autoreply component
import Logs from './Logs'; // Import your Logs component
import { getConnectedDevice } from '../common/whatsapp';
import FacebookWhatsAppSignup from './FacebookWhatsAppSignup';

import GridItem from "components/Grid/GridItem.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomTabs from "../../components/CustomTabs/CustomTabs";
import Template from './template';
import Inbox from './inbox/inbox';
import Broadcast from './Broadcast';
import pageAccess from '../../helper/pageAcess';

const MetaWhatsappPage = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const [devicesList, setDevicesList] = useState(null);
  const [phoneSelectionOptions, setphoneSelectionOptions] = useState([]);
  const [whatsappAccountSelectionOptions, setwhatsappAccountSelectionOptions] = useState([]);
  const {user}= props;

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(async () => {
    if(!user.admin) return true;

    const devicesList = await getConnectedDevice({admin:user.admin,username:user.username});
    setDevicesList(devicesList.devices)
    let phoneselections = [];
    let wbaOptions = [];
    devicesList.devices.map((device) => {
      phoneselections.push({ key: device.phoneNumberId, value: device.getPhoneDetailsResponse.display_phone_number });
    })
    setphoneSelectionOptions(phoneselections)
    devicesList.devices.map((device) => {
      wbaOptions.push({ id: device.whatsappBusinessAccountId, name: device.whatsappBusinessAccountId });
    })
    setwhatsappAccountSelectionOptions(wbaOptions)
  }, [user]);

  const haveNoAccess = pageAccess({user:user});
  if(haveNoAccess){
    return haveNoAccess;
  }


  return (
    <Box sx={{ width: '100%' }}>
    <br/>
    <br/>
      {/* Tabs */}


      { devicesList && <>
      <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
            title=""
            TabProps={{
              onChange: handleChange,
            }}
            selectedValue={activeTab}
            headerColor="info"
            tabs={[
              {
                tabName: "Connected Whatsapp",
                tabContent: (
                  <>
                    <CardBody>
                    <FacebookWhatsAppSignup {...props} devicesList={devicesList} phoneSelections={phoneSelectionOptions} />
                    </CardBody>
                  </>
                ),
              },
              {
                tabName: "AutoReply",
                tabContent: (
                  <CardBody>
                   <Autoreply {...props} devicesList={devicesList}  phoneSelections={phoneSelectionOptions}/>

                  </CardBody>
                ),
              },
              {
                tabName: "Template",
                tabContent: (
                  <CardBody>
                   <Template {...props}  devicesList={devicesList} whatsappAccountSelectionOptions={whatsappAccountSelectionOptions}  phoneSelections={phoneSelectionOptions}/>

                  </CardBody>
                ),
              },
              {
                tabName: "Broadcast",
                tabContent: (
                  <CardBody>
                    <Broadcast {...props} devicesList={devicesList} phoneSelections={phoneSelectionOptions} whatsappAccountSelectionOptions={whatsappAccountSelectionOptions} />
                  </CardBody>
                ),
              },
              {
                tabName: "Log",
                tabContent: (
                  <CardBody>

<Logs {...props} devicesList={devicesList}/>
                  </CardBody>
                ),
              },
             
            ]}
          />
        </GridItem>



      </>

      }
    </Box>
  );
};

// TabPanel Component
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export default MetaWhatsappPage;